<template>
    <section class="RightBody">
        <b-card-group>
            <div v-for="item in prjDetails" class="item">
                <b-link :href="item.sysUrl" target="_blank">
                    <b-card :img-src="item.imgPath + item.imgName" img-alt="Image" :title="item.sysName" tag="article"
                        style="max-width: 14rem;" class="mb-2 lg-2">
                        <b-card-text>
                            {{ item.description }}
                        </b-card-text>
                    </b-card>
                </b-link>
            </div>
        </b-card-group>
    </section>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import {
    queryByPage
} from "@/api/com/common.js";
export default {
    name: 'RightBody',
    data() {
        return {
            prjDetails: [{
                "sysName": "NAS管理窗口",
                "description": "我的存储服务器。",
                "sysUrl": "https://nas.simyuan.com:5001/",
                "imgPath": "/img/",
                "imgName": "bird.jpg"
            }]
        }
    },
    components: {},
    watch: {},
    beforeCreate() {
        let param = {
            ProjectDetails: {
                // id: 1,
                // sysName: "NAS管理窗口",
            },
            pageRequest: {
                page: 0,
                size: 40
            }
        }
        console.log(param);
        queryByPage(param).then(result => {
            console.log(result.data.content);
            this.prjDetails = result.data.content;
        })
    },
    methods: {}
}
</script>

<style scoped>
/* .col {
    -ms-flex-preferred-size: 0;
    flex-basis: 0;
    -ms-flex-positive: 1;
    flex-grow: 1;
    max-width: 100%;
}

.row {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-right: 3%;
    margin-left: 0%;
    box-sizing: border-box;
} */

/* .img-fluid {
    max-width: 110%;
    max-height: 100%;
    padding: bottom;
} */

.item {
    margin-left: 1%;
    margin-right: 1%;
    margin-top: 1%;
    margin-bottom: 1%;
}
</style>
